import React from 'react';
import { connect } from 'react-redux';

import Day from './Day';
import Console from '../../../lib/debug';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

const MONTH_TYPES = [
    ProgramTypes.TYPES.TEAM,
    ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.CALENDAR
];

const checkIsProgram = type => {
    if (!type) {
        return false;
    }

    return !MONTH_TYPES.includes(type);
};

const Week = props => {
    Console.render('Week');
    const { num, dayList, trainingWeekStartsOnMonday, programType } = props;
    let days = [];
    let weekIndex = num * 7;
    let dayLength = dayList.length;
    const isProgram = checkIsProgram(programType);
    for (let i = 0; i < 7; i++) {
        if (i === 0 && trainingWeekStartsOnMonday && !isProgram) {
            continue;
        }
        if (weekIndex + (i <= dayLength - 1)) {
            let dayKey = dayList[weekIndex + i];
            if (dayKey) {
                days.push(
                    <Day
                        key={'w' + num + 'd' + i}
                        weekIndex={num}
                        dayIndex={i}
                        dayKey={dayKey}
                    />
                );
            }
        }
    }
    if (trainingWeekStartsOnMonday && !isProgram) {
        const dayKey = dayList[weekIndex + 7];
        if (dayKey) {
            days.push(
                <Day
                    key={'w' + num + 'd0'}
                    weekIndex={num}
                    dayIndex={0}
                    dayKey={dayKey}
                />
            );
        }
    }

    return <div className="week">{days}</div>;
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        dayList: state.calendar.dayList,
        programType: state.calendar.infoTree.programType,
        trainingWeekStartsOnMonday:
            state.app &&
            state.app.userProfile &&
            state.app.userProfile.training_week_starts_on_monday
    };
};

export default connect(mapStateToProps)(Week);



// WEBPACK FOOTER //
// ./src/view/calendar/components/Week.jsx